import React from "react";
import NewLoader from "../../../components/styled-components/loader/NewLoader";

export const DebtAmortization = ({ amortizationData, loading }) => {
  const formatNumber = (value) => {
    if (
      value === null ||
      value === undefined ||
      value === "" ||
      isNaN(Number(value))
    ) {
      return "0.00"; // Or return "-" if you prefer
    }

    return Number(value).toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  // Function to get the most recent past date
  const getMostRecentPastDate = (data) => {
    if (!data || data.length === 0) return null;

    const today = new Date();
    const pastDates = data
      .map((item) => ({ ...item, dateObj: parseDate(item.date) }))
      .filter((item) => item.dateObj <= today);

    if (pastDates.length === 0) return null;

    return pastDates.reduce((latest, current) =>
      current.dateObj > latest.dateObj ? current : latest
    );
  };

  // Convert MM-DD-YYYY to Date object
  const parseDate = (dateStr) => {
    const [month, day, year] = dateStr.split("-");
    return new Date(`${year}-${month}-${day}`);
  };

  // Get the most recent date that should be highlighted
  const recentDate = getMostRecentPastDate(amortizationData);

  return (
    <div
      className="debt-amortization-container"
      style={{ marginTop: "20px", position: "relative" }}
    >
      <div
        className="cardHeadingDebt"
        style={{ fontWeight: "bold", fontSize: "18px", marginBottom: "10px" }}
      >
        Amortization Details
      </div>

      {amortizationData && amortizationData.length > 0 ? (
        <div
          style={{
            maxHeight: "300px",
            overflowY: "auto",
            border: "1px solid #ddd",
            borderRadius: "8px",
          }}
        >
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              textAlign: "left",
            }}
          >
            <thead>
              <tr
                style={{
                  background: "rgb(244, 247, 254)",
                  position: "sticky",
                  top: 0,
                }}
              >
                <th style={thStyle}>Date</th>
                <th style={thStyle}>Interest Rate</th>
                <th style={thStyle}>Monthly Payment</th>
                <th style={thStyle}>Interest Paid</th>
                <th style={thStyle}>Principal Paid</th>
                <th style={thStyle}>Balance</th>
                <th style={thStyle}>Cumulative Interest</th>
                <th style={thStyle}>Cumulative Principal</th>
              </tr>
            </thead>
            <tbody>
              {amortizationData.map((item, index) => {
                const isHighlighted =
                  recentDate && item.date === recentDate.date;

                return (
                  <tr
                    key={index}
                    style={{
                      borderBottom: "1px solid #eee",
                      background: isHighlighted ? "#fff3cd" : "transparent", // Yellow highlight
                    }}
                  >
                    <td style={tdStyle}>{item.date}</td>
                    <td style={tdStyle}>{formatNumber(item.interestRate)}%</td>
                    <td style={tdStyle}>
                      ${formatNumber(item.monthlyPayment)}
                    </td>
                    <td style={tdStyle}>
                      ${formatNumber(item.interestRatePaid)}
                    </td>
                    <td style={tdStyle}>${formatNumber(item.principalPaid)}</td>
                    <td style={tdStyle}>${formatNumber(item.balance)}</td>
                    <td style={tdStyle}>
                      ${formatNumber(item.cumulativeInterest)}
                    </td>
                    <td style={tdStyle}>
                      ${formatNumber(item.cumulativePrincipal)}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="debt-amortization-container-nocontent">
          <div className="debt-amortization-container-nocontent-heading">
            No data to show
          </div>
        </div>
      )}
      <NewLoader isLoading={loading} />
    </div>
  );
};

const thStyle = {
  padding: "10px",
  fontFamily: "Poppins",
  borderBottom: "1px solid #ddd",
  fontWeight: "bold",
  color: "black",
  fontSize: "14px",
};

const tdStyle = {
  padding: "10px",
  fontSize: "14px",
  fontFamily: "Poppins",
  fontWeight: "500",
  color: "#6c757d",
  whiteSpace: "nowrap",
};
